(function () {
  let firstPartyAssetPattern =
    /\/assets\/(affirmDirectCheckout|affirmUiGuard|affirmShopify|termsAcceptance|theme)\.js/;

  function getExceptionValues(event) {
    return event.exception && event.exception.values ? event.exception.values : [];
  }

  function getFrames(event) {
    let frames = [];
    let values = getExceptionValues(event);

    for (let index = 0; index < values.length; index += 1) {
      let stacktrace = values[index].stacktrace;

      if (!stacktrace || !stacktrace.frames) {
        continue;
      }

      frames = frames.concat(stacktrace.frames);
    }

    return frames;
  }

  function frameFilename(frame) {
    return frame.filename || frame.abs_path || "";
  }

  function getErrorMessage(event) {
    let values = getExceptionValues(event);

    if (values.length && values[0].value) {
      return values[0].value;
    }

    if (event.message) {
      return event.message;
    }

    return "";
  }

  function getUserAgent(windowRef) {
    if (!windowRef.navigator || !windowRef.navigator.userAgent) {
      return "";
    }

    return String(windowRef.navigator.userAgent);
  }

  function hasFirstPartyFrame(frames) {
    for (let index = 0; index < frames.length; index += 1) {
      if (firstPartyAssetPattern.test(frameFilename(frames[index]))) {
        return true;
      }
    }

    return false;
  }

  function hasVendorTrackedFrame(frames) {
    for (let index = 0; index < frames.length; index += 1) {
      let filename = frameFilename(frames[index]);

      if (
        filename.indexOf("/extensions/") !== -1 ||
        filename.indexOf("/web-pixels") !== -1
      ) {
        return true;
      }
    }

    return false;
  }

  function hasFrameMatching(frames, pattern) {
    for (let index = 0; index < frames.length; index += 1) {
      if (pattern.test(frameFilename(frames[index]))) {
        return true;
      }

      if (frames[index].function && pattern.test(frames[index].function)) {
        return true;
      }
    }

    return false;
  }

  function isTermsLoadFailureMessage(message) {
    return message === "terms content load failed";
  }

  function isTermsCheckoutDiagnosticMessage(message) {
    return message === "terms checkout diagnostic";
  }

  function isShopJsChunkImportFailure(message) {
    return (
      /Unable to fetch .*shopifycloud\/shop-js/.test(message) ||
      /load error: .*shopifycloud\/shop-js/.test(message)
    );
  }

  function isWebPixelsManagerInitFailure(message, frames) {
    if (/webPixelsManager\.init/.test(message)) {
      return true;
    }

    if (!/reading ['"]init['"]|read property ['"]init['"]/.test(message)) {
      return false;
    }

    if (hasFirstPartyFrame(frames) || hasVendorTrackedFrame(frames)) {
      return false;
    }

    return hasFrameMatching(
      frames,
      /HTMLScriptElement|^(?:\?\()?https:\/\/[^/]+\/(?:products|collections|cart|pages|blogs|search)/
    );
  }

  function isKlaviyoChunkLoadFailure(message, frames) {
    if (message.indexOf("Loading chunk") === -1) {
      return false;
    }

    return (
      /onsite\/js\//.test(message) ||
      hasFrameMatching(frames, /onsite\/js\//)
    );
  }

  function isShopJsDynamicImportFailure(message) {
    return /(?:Failed to fetch|error loading) dynamically imported module:.*shopifycloud\/shop-js/.test(
      message
    );
  }

  function isShopJsModuleImportFailure(message, frames) {
    if (message.indexOf("Importing a module script failed") === -1) {
      return false;
    }

    return (
      /shopifycloud\/shop-js/.test(message) ||
      hasFrameMatching(frames, /shopifycloud\/shop-js/)
    );
  }

  function isJsonLdTelephoneParserError(message, frames) {
    if (!/hasOwnProperty\.call\([^,]+,"telephone"\)/.test(message)) {
      return false;
    }

    return hasFrameMatching(frames, /extract(?:Filtered)?SchemaValuesFromJSONLD/);
  }

  function isBrowserExtensionTabError(message) {
    return (
      message === "Error: Invalid call to runtime.sendMessage(). Tab not found." ||
      message === "Invalid call to runtime.sendMessage(). Tab not found."
    );
  }

  function isSymantecBrowserInjectionError(message) {
    return /SymBrowser_Modify(?:AnchorTag|WindowOpen)WithTarget/.test(message);
  }

  function isMediaPlaybackInterruption(message) {
    return message.indexOf("play() request was interrupted") !== -1;
  }

  function isImportMapSrcdocMutationError(message, frames) {
    if (message.indexOf("Cannot assign to read only property 'srcdoc'") === -1) {
      return false;
    }

    return hasFrameMatching(frames, /importmap-polyfill\/es-modules-shim/);
  }

  function isNativeBrowserBridgeFailure(event, windowRef) {
    let values = event && event.exception && event.exception.values;
    if (!values || values.length !== 1) return false;

    let exception = values[0];
    let frames = (exception.stacktrace && exception.stacktrace.frames) || [];
    let userAgent = getUserAgent(windowRef);
    if (!/iPhone|iPad|iPod/.test(userAgent) || !/AppleWebKit\//.test(userAgent)) return false;

    // WebKit emits this when an app's script-message recipient has been destroyed.
    // Keep any JavaScript caller visible: the captured GSA event was stackless.
    if (
      exception.type === "Error" &&
      exception.value === "The WKWebView was deallocated before the message was delivered"
    ) {
      return /GSA\//.test(userAgent) && frames.length === 0;
    }

    // Aippy's own UA and helper namespace identify this app-injected performance
    // probe. Its line-1 call cannot be the storefront's <!doctype html> source.
    return (
      /Aippy\/[\d.]+\/\d+\/iOS\//.test(userAgent) &&
      exception.type === "TypeError" &&
      exception.value === "window.__aippy_perf_get is not a function. (In 'window.__aippy_perf_get()', 'window.__aippy_perf_get' is undefined)" &&
      frames.length === 1 &&
      frames[0].function === "global code" &&
      frames[0].lineno === 1 &&
      frames[0].colno === 24 &&
      /^https:\/\/electroandcompany\.com\/(?:products|collections)\/[^?#]+(?:[?#].*)?$/.test(frames[0].filename || "") &&
      !/\.(?:js|mjs)(?:[?#]|$)/i.test(frames[0].filename || "")
    );
  }

  function isInAppBrowserWebkitError(message, frames) {
    if (!/webkit\.messageHandlers/.test(message)) {
      return false;
    }

    return !hasFirstPartyFrame(frames);
  }

  function isInAppBrowserBridgeFrameError(frames) {
    return hasFrameMatching(frames, /iabjs:\/\//);
  }

  function isObsoleteAndroidWebViewInitError(message, windowRef) {
    if (message.indexOf("Cannot read property 'init' of undefined") === -1) {
      return false;
    }

    let userAgent = getUserAgent(windowRef);

    if (!/[;)] ?wv[);]/.test(userAgent)) {
      return false;
    }

    let version = userAgent.match(/Chrome\/(\d+)\./);

    return Boolean(version && Number(version[1]) < 60);
  }

  function isProxyRewrittenPageError(frames, event) {
    if (hasFrameMatching(frames, /worker-hammerhead|\/voya\//)) {
      return true;
    }
    if (getExceptionValues(event).length !== 1) {
      return false;
    }
    if (hasFirstPartyFrame(frames)) {
      return false;
    }

    function sourceUrl(frame) {
      return frame.abs_path || frameFilename(frame);
    }
    let lucideRuntime = "https://cdn.jsdelivr.net/gh/lucideproxy/svg@latest/hn2rh/gu3e68.js";
    return getExceptionValues(event).some(function (exception) {
      let stack = exception.stacktrace && exception.stacktrace.frames || [];
      let last = stack[stack.length - 1];
      let previous = stack[stack.length - 2];
      let message = exception.value || "";

      // Exact encoded-module namespace from the stackless AA import failure.
      if (exception.type === "TypeError" && stack.length === 0) {
        return message.indexOf("Failed to fetch dynamically imported module: https://cdn.jsdelivr.net/gh/lucideproxy/svg@latest/buixee/") === 0;
      }
      if (!last) {
        return false;
      }

      // Sep17 native Full/Raw stacks pin four failures in this rewritten runtime.
      // Exact sources, messages and complete chains only; no proxy-host wildcard.
      let kidsAccount = "https://kidsclassnest.com/cdn/w/hvtrs8%2F-cfn%2Csjoridy%2Ccmm-svopedrmnv%2Fue%60-aoopmngnvs-aacmult%2Cjq";
      let kidsZendesk = "https://kidsclassnest.com/cdn/w/hvtrs8%2F-svavia.xdcsqevs%2Ccmm-eir-slirpgt%2Cjq%3Fie%7B%3D7b505b%3A0%2Fefb7-6b%3A3%2Faa66-dc7f%60018094f";
      let kidsPage = "https://kidsclassnest.com/cdn/w/hvtrs8%2F-eneatpocnfcmmraly%2Ccmm-cmlneatkols-sz520";
      function exactProxyFrame(frame, expectedSource, line, column, fn) {
        return frame && sourceUrl(frame) === expectedSource &&
          (!frame.filename || frame.filename === expectedSource) &&
          (!frame.abs_path || frame.abs_path === expectedSource) &&
          frame.lineno === line && frame.colno === column &&
          (fn === "?" ? (!frame.function || frame.function === "?") : frame.function === fn);
      }
      if (exception.type === "TypeError") {
        if (stack.length === 1 && (
          (message === "t is not a constructor" && exactProxyFrame(last, kidsAccount, 1, 28171, "?")) ||
          (message === "Cannot read properties of undefined (reading 'InboundFilters')" && exactProxyFrame(last, kidsZendesk, 1, 9432, "?")) ||
          (message === "Failed to fetch dynamically imported module: " + kidsPage && exactProxyFrame(last, kidsPage, 0, 0, "?")))) {
          return true;
        }
        if (message === "W.produceHistogram is not a function" && stack.length === 3 &&
          exactProxyFrame(stack[0], kidsAccount, 1, 26485, "?") &&
          exactProxyFrame(stack[1], kidsAccount, 1, 11366, "ot") &&
          exactProxyFrame(stack[2], kidsAccount, 1, 11251, "?")) {
          return true;
        }
      }

      // Sep18 native stacks pin three failures in this external UV runtime.
      // Require the complete chain and exact sources, including conflicting fields.
      let familyAccount = "https://browse.familyguy.in/uv/service/hvtrs8%2F-cfn%2Csjoridy%2Ccmm-svopedrmnv%2Fue%60-aoopmngnvs-aacmult%2Cjq";
      let familyPage = "https://browse.familyguy.in/uv/service/hvtrs8%2F-eneatpocnfcmmraly%2Ccmm-cmlneatkols-bkkgs-ppofuatq%2Fgto-ptp-nive%2Feneatpia-vrcin-oaahkng-pecd%7B-vo%2Frkp";
      if (exception.type === "TypeError") {
        if (stack.length === 1 && (
          (message === "t is not a constructor" && exactProxyFrame(last, familyAccount, 1, 28171, "?")) ||
          (message === "Failed to fetch dynamically imported module: " + familyPage && exactProxyFrame(last, familyPage, 0, 0, "?")))) {
          return true;
        }
        if (message === "W.produceHistogram is not a function" && stack.length === 3 &&
          exactProxyFrame(stack[0], familyAccount, 1, 26485, "?") &&
          exactProxyFrame(stack[1], familyAccount, 1, 11366, "ot") &&
          exactProxyFrame(stack[2], familyAccount, 1, 11251, "?")) {
          return true;
        }
      }

      // Sep20: exact single-frame failures from this external UV proxy.
      let fiwersZendesk = "https://sha.fiwers.cl/uv/service/hvtrs8%2F-svavia.xdcsqevs%2Ccmm-eir-slirpgt%2Cjq%3Fie%7B%3D7b505b%3A0%2Fefb7-6b%3A3%2Faa66-dc7f%60018094f";
      let fiwersPage = "https://sha.fiwers.cl/uv/service/hvtrs8%2F-eneatpocnfcmmraly%2Ccmm-cmlneatkols-bkkgs";
      if (exception.type === "TypeError" && stack.length === 1 && (
          (message === "Cannot read properties of undefined (reading 'InboundFilters')" &&
            exactProxyFrame(last, fiwersZendesk, 1, 9432, "?")) ||
          (message === "Failed to fetch dynamically imported module: " + fiwersPage &&
            exactProxyFrame(last, fiwersPage, 0, 0, "?")))) {
        return true;
      }

      // CV: native Full Stack Trace pins an external worker wrapper and loader.
      // Match only this failure; preserve other workers and conflicting sources.
      let cvWorkerSource = "https://c55d416c.apweb.quest/study-path/AAAAANAAEAAVAAAABOABaABLAAcAAzAAVAAbAArAAZABeAAJAAXAAUAAGAAcAAZAAFAAFAAXAAmABeAAbAAwAAGAAeAAfAAcAASABIAADAAdAANAABAAVAAsAAwABIAA-ABYABSABRAAcABHABVAAEAAQABNAAGABJABuAASAAaABtAAbAAJABRABBAAVABUABBABBABCAAJABOAA6ABJABKAA-AAIABSABcABWAAHAAAAARABZAAFAANAABAA6AAcABVABtABZAAAABdABMABBABVABAABFABBAAkAAaABpABDAAbABqAAJAAGABaAAaABIAABABEABDAAXAABABMAA5ABCAAcABtABcABVABZABNAATABVABLABFAARAAFABKABnABfAALAA-AAFABVAAKAAWAAIABKAAEAAbAAHAAPAAcAAtABeAAVAAwAAPABUAAaAAXABeAAPAAA?dest=worker";
      if (stack.length === 1 && (!last.function || last.function === "?") &&
        exception.type === "Error" && message === "Uncaught NetworkError: Failed to execute 'importScripts' on 'WorkerGlobalScope': The script at 'https://c55d416c.apweb.quest/study-core/ld.bin' failed to load." &&
        last.lineno === 1 && last.colno === 1 && sourceUrl(last) === cvWorkerSource &&
        (!last.filename || last.filename === cvWorkerSource) &&
        (!last.abs_path || last.abs_path === cvWorkerSource)) {
        return true;
      }

      // These single-frame signatures were observed in the educationate proxy.
      // AH's native source shows MessagePort and BareClient transport setup.
      // Pin sources and reject additional callers so real app errors stay visible.
      if (stack.length === 1 && (!last.function || last.function === "?")) {
        if (exception.type === "TypeError" && message === "Cannot read properties of undefined (reading 'InboundFilters')" &&
          sourceUrl(last) === "https://s3.amazonaws.com/educationate/q/r/111747361e58595f0a1752320401580a1d0240350816055e1a0c5e690809045f0a0d5a361d07025e13100c2d081b4b451b5403710f5a465d1c075173405614484a4e52255b565b161a5655245d514e42405555" && last.lineno === 1 && last.colno === 9432) {
          return true;
        }
        if (exception.type === "Error" && message === "Uncaught TypeError: Right-hand side of 'instanceof' is not an object" &&
          sourceUrl(last) === "https://s3.amazonaws.com/educationate/q/a.js" && last.lineno === 1 && last.colno === 317) {
          return true;
        }
        // Sep14 native Full Stack Trace pins these UV targets. Do not match a
        // proxy host/prefix alone: preserve other modules, callers and messages.
        // Other observed UV failures remain pinned to their exact module and location.
        if (exception.type === "TypeError" && message === "t is not a constructor" && sourceUrl(last) === "https://8021688600113732413547102395624276084104729385610293875616.estoniaeducation.info/uv/service/hvtrs8%2F-cfn%2Csjoridy%2Ccmm-svopedrmnv%2Fue%60-aoopmngnvs-aacmult%2Cjq" && last.lineno === 1 && last.colno === 28171) {
          return true;
        }
        if (exception.type === "TypeError" && message === "Cannot read properties of undefined (reading 'InboundFilters')" && sourceUrl(last) === "https://8021688600113732413547102395624276084104729385610293875616.estoniaeducation.info/uv/service/hvtrs8%2F-svavia.xdcsqevs%2Ccmm-eir-slirpgt%2Cjq%3Fie%7B%3D7b505b%3A0%2Fefb7-6b%3A3%2Faa66-dc7f%60018094f" && last.lineno === 1 && last.colno === 9432) {
          return true;
        }
        let classlinkImportTarget = "https://classlink.online/service/hvtrs8%2F-eneatpocnfcmmraly%2Ccmm-ppofuatq%2Fgto-ptp-nive%2Feneatpia-vrcin-oaahkng-pecd%7B-vo%2Frkp";
        let uvImportTargets = [classlinkImportTarget, "https://8021688600113732413547102395624276084104729385610293875616.estoniaeducation.info/uv/service/hvtrs8%2F-eneatpocnfcmmraly%2Ccmm-cmlneatkols-bkkgs", "https://8021688600113732413547102395624276084104729385610293875616.estoniaeducation.info/uv/service/hvtrs8%2F-eneatpocnfcmmraly%2Ccmm-cmlneatkols-bkkgs-ppofuatq%2F0006%2Fevm%2Frvr%2Fsropt%2Frgafy%2Ftm-pir-glgcvrkc%2Ftpakl%2Fmccjile"];
        if (exception.type === "TypeError" && last.lineno === 0 && last.colno === 0 && uvImportTargets.indexOf(sourceUrl(last)) !== -1) {
          // Reject conflicting nonempty source fields for this newly pinned target.
          if (sourceUrl(last) === classlinkImportTarget && last.filename && last.filename !== classlinkImportTarget) {
            return false;
          }
          return message === "Failed to fetch dynamically imported module: " + sourceUrl(last) ||
            (sourceUrl(last) === "https://8021688600113732413547102395624276084104729385610293875616.estoniaeducation.info/uv/service/hvtrs8%2F-eneatpocnfcmmraly%2Ccmm-cmlneatkols-bkkgs-ppofuatq%2F0006%2Fevm%2Frvr%2Fsropt%2Frgafy%2Ftm-pir-glgcvrkc%2Ftpakl%2Fmccjile" && message === "Failed to fetch dynamically imported module: https://8021688600113732413547102395624276084104729385610293875616.estoniaeducation.info/uv/service/hvtrs8%2F-eneatpocnfcmmraly%2Ccmm-cmlneatkols-bkkgs-ppofuatq%2F0006%2Fevm%2Frvr%2Fsropt%2Frgafy%2Ftm-pir-...");
        }
        let proxyImportTargets = ["https://s3.amazonaws.com/educationate/q/r/111747361e58595f1c0f562519101911170750290012171e004d5029004d151f150f5625190b191e0a4c4127170d045d180050231e111902100640791d0311154451", "https://s3.amazonaws.com/educationate/q/r/111747361e58595f1c0f562519101911170750290012171e004d5029004d49030b105f3204064b311f0e710902104e1b1d1574023e0331192056457e54173846492e6370212f04440b3442001f5a1111163b7b31233813061d5a592c5a573e"];
        if (exception.type === "TypeError" && proxyImportTargets.indexOf(sourceUrl(last)) !== -1) {
          let expected = "Failed to fetch dynamically imported module: " + sourceUrl(last);
          // Accept the observed truncated AA value; the complete frame stays pinned.
          return message === expected || (sourceUrl(last) === "https://s3.amazonaws.com/educationate/q/r/111747361e58595f1c0f562519101911170750290012171e004d5029004d49030b105f3204064b311f0e710902104e1b1d1574023e0331192056457e54173846492e6370212f04440b3442001f5a1111163b7b31233813061d5a592c5a573e" && message === "Failed to fetch dynamically imported module: https://s3.amazonaws.com/educationate/q/r/111747361e58595f1c0f562519101911170750290012171e004d5029004d49030b105f3204064b311f0e710902104e1b1d1574023e0331192056457e54173846492e6370212f04440b3442001f5a1111163...");
        }
      }

      // Only bypass vendor tracking when the failure terminates in these proxy
      // fetch shims. An earlier proxy frame does not explain a later app error.
      if (exception.type === "TypeError" && message === "Failed to fetch") {
        return (
          sourceUrl(last) === "fetch.sj" && last.function === "apply" && previous &&
          sourceUrl(previous) === lucideRuntime && previous.function === "RawProxy.r.apply.l.apply"
        ) || (
          sourceUrl(last) === "https://s3.amazonaws.com/fernvcsa/lveh/nzdz.all.js" &&
          last.function === "RawProxy.r.apply.a.apply"
        );
      }
      if (exception.type === "QuotaExceededError" && message === "Failed to execute 'setItem' on 'Storage': Setting the value of 'electroandcompany.com@__up_essentialMetrics' exceeded the quota.") {
        return sourceUrl(last) === lucideRuntime && last.function === "Proxy.<anonymous>";
      }
      if (hasVendorTrackedFrame(frames)) {
        return false;
      }
      // The public AH bootstrap identifies itself as Ultraviolet/UVClient.
      // https://instructure.storage.googleapis.com/q/a.js
      if (exception.type === "Error" && message === "Uncaught TypeError: Right-hand side of 'instanceof' is not an object") {
        return sourceUrl(last) === "https://instructure.storage.googleapis.com/q/a.js";
      }
      if (exception.type === "RangeError" && message === "WebAssembly.Instance(): Out of memory: Cannot allocate Wasm memory for new instance") {
        return sourceUrl(last) === lucideRuntime;
      }
      if (exception.type === "TypeError" && message === "Cannot read properties of undefined (reading 'InboundFilters')") {
        return /^https:\/\/browse\.familyguy\.in\/uv\/service\/hvtrs8%2F-/.test(sourceUrl(last));
      }
      if (exception.type === "QuotaExceededError" && message.indexOf("Setting the value of '__uv$https://electroandcompany.com@") !== -1 && message.indexOf("exceeded the quota.") !== -1) {
        return sourceUrl(last) === "https://browse.familyguy.in/uv/uv.client.js" && !last.function && previous && sourceUrl(previous) === "https://browse.familyguy.in/uv/uv.client.js" && previous.function === "Proxy.setItem" && stack.some(function (frame) {
          return /^https:\/\/browse\.familyguy\.in\/uv\/service\/hvtrs8%2F-/.test(sourceUrl(frame));
        });
      }
      return false;
    });
  }

  function isGoogleAppInstrumentationError(frames) {
    return hasFrameMatching(frames, /findTopmostVisibleElement|isOpaqueElement/);
  }

  function isClickSimulatorChildrenError(message, frames, event) {
    if (getExceptionValues(event).length !== 1) {
      return false;
    }
    if (
      message !== "Cannot read properties of null (reading 'children')" ||
      hasFirstPartyFrame(frames) ||
      hasVendorTrackedFrame(frames)
    ) {
      return false;
    }

    // SHOPIFY-STOREFRONT-CA: injected simulator code, not our DOM observers.
    return frames.some(function (frame) {
      return frame.function === "ClickSimulator.scanDocument";
    }) && frames.some(function (frame) {
      return frame.function === "ClickSimulator.getSelectorPath";
    });
  }

  function isDictionaryTimeoutRejection(event, frames) {
    if (getExceptionValues(event).length !== 1) {
      return false;
    }
    if (hasFirstPartyFrame(frames) || hasVendorTrackedFrame(frames)) {
      return false;
    }

    // Observed language-tool requests sharing the SHOPIFY-STOREFRONT-B5 trace.
    // Keep this explicit: generic timeouts and new request names remain visible.
    let identifiers = [
      "availableLanguagesDistributor.getValue",
      "topicsDistributor.getValue",
      "ru_wordsDistributor.getValue",
      "ua_wordsDistributor.getValue",
      "fr_wordsDistributor.getValue",
      "textCheckersDistributor.getValue",
      "es_wordsDistributor.getValue",
      "nn-NO_wordsDistributor.getValue",
      "nb-NO_wordsDistributor.getValue",
      "lettersVoicesDistributor.getValue",
      "appSettingsDistributor.getValue",
      "predictionDistributor.getValue",
      "dictateStateDistributor.getValue",
      "availableTextCheckLanguagesDistributor.getValue",
      "ac_wordsDistributor.getValue",
      "de_wordsDistributor.getValue",
      "en_wordsDistributor.getValue",
      "DefineExpirationForLanguagePacks.getValue",
      "userDistributor.getValue",
      "speechVoicesDistributor.getValue",
      "isDictateAvailable",
      "isPredictionAvailable",
      "isMathOcrAvailable",
      "getDictionariesByLanguageId",
      "dictionariesDistributor.getValue"
    ];
    let prefix = "Non-Error promise rejection captured with value: Request timeout ";
    return getExceptionValues(event).some(function (exception) {
      if (
        exception.type !== "UnhandledRejection" ||
        typeof exception.value !== "string" ||
        exception.value.indexOf(prefix) !== 0
      ) {
        return false;
      }
      return identifiers.indexOf(exception.value.slice(prefix.length)) !== -1;
    });
  }

  function isGoogleTranslateLaRejection(event, frames, windowRef) {
    if (getExceptionValues(event).length !== 1) {
      return false;
    }
    let userAgent = getUserAgent(windowRef);
    if (
      !/(iPhone|iPad|iPod)/.test(userAgent) ||
      !/(?:CriOS|GSA)\/[\d.]+/.test(userAgent) ||
      !windowRef.location ||
      !windowRef.location.href ||
      hasFirstPartyFrame(frames) ||
      hasVendorTrackedFrame(frames)
    ) {
      return false;
    }

    let documentUrl;
    try {
      documentUrl = new URL(windowRef.location.href);
    } catch (error) {
      return false;
    }
    documentUrl.hash = "";

    // Google Translate el_main, build yXXpsDfy_o8.O, matches these exact calls.
    // https://translate.googleapis.com/_/translate_http/_/js/k=translate_http.tr.en_US.yXXpsDfy_o8.O/am=BECAAQ/d=1/ed=1/rs=AN8SPfp48RJejHiR7vfEass6hCfDma27HQ/m=el_main
    // Chromium's iOS TranslateController::OnScriptLoaded evaluates this bundle:
    // https://chromium.googlesource.com/chromium/src/+/refs/heads/main/components/translate/ios/browser/translate_controller.mm
    return getExceptionValues(event).some(function (exception) {
      let stack = exception.stacktrace && exception.stacktrace.frames;
      if (exception.type !== "Error" || exception.value !== "La" || !stack || stack.length !== 3) {
        return false;
      }
      if (!stack.every(function (frame) {
        let filename = frameFilename(frame);
        return filename === documentUrl.href || filename === documentUrl.pathname + documentUrl.search;
      })) {
        return false;
      }
      return (
        !stack[0].function && stack[0].lineno === 195 && stack[0].colno === 338 &&
        stack[1].function === "Ui" && stack[1].lineno === 194 && stack[1].colno === 41 &&
        !stack[2].function && (stack[2].lineno === 460 || stack[2].lineno === 461) && stack[2].colno === 363
      );
    });
  }

  function isGoogleIosGeneratorRejection(event, frames, windowRef) {
    let exceptions = getExceptionValues(event);
    let userAgent = getUserAgent(windowRef);
    if (
      exceptions.length !== 1 ||
      !/(iPhone|iPad|iPod)/.test(userAgent) ||
      !/(?:CriOS|GSA)\/[\d.]+/.test(userAgent) ||
      !windowRef.location || !windowRef.location.href ||
      hasFirstPartyFrame(frames) || hasVendorTrackedFrame(frames)
    ) {
      return false;
    }
    let exception = exceptions[0];
    let stack = exception.stacktrace && exception.stacktrace.frames;
    if (exception.type !== "Error" || !stack || stack.length !== 3) {
      return false;
    }

    // Ownership is inferred from the observed Google iOS browser + document-only
    // generator stack matching the verified Translate pattern. Historical bundle
    // versions for these exact symbols have not been recovered. Do not generalize
    // the short error names or reuse this rule for differently shaped stacks.
    // Chromium injects Translate scripts via TranslateController::OnScriptLoaded:
    // https://chromium.googlesource.com/chromium/src/+/refs/heads/main/components/translate/ios/browser/translate_controller.mm
    let signatures = {
      Ea: { functionName: "Ji", firstLine: 195, firstColumn: 338, generatorLine: 194, finalLines: [453, 454, 466] },
      Da: { functionName: "Mi", firstLine: 195, firstColumn: 338, generatorLine: 194, finalLines: [449] },
      Ca: { functionName: "Ii", firstLine: 192, firstColumn: 191, generatorLine: 191, finalLines: [444] }
    };
    let signature = Object.prototype.hasOwnProperty.call(signatures, exception.value) ? signatures[exception.value] : null;
    if (!signature) {
      return false;
    }
    let documentUrl;
    try {
      documentUrl = new URL(windowRef.location.href);
    } catch (error) {
      return false;
    }
    documentUrl.hash = "";
    if (!stack.every(function (frame) {
      let filename = frameFilename(frame);
      return filename === documentUrl.href || filename === documentUrl.pathname + documentUrl.search;
    })) {
      return false;
    }
    return (
      !stack[0].function && stack[0].lineno === signature.firstLine && stack[0].colno === signature.firstColumn &&
      stack[1].function === signature.functionName && stack[1].lineno === signature.generatorLine && stack[1].colno === 41 &&
      !stack[2].function && signature.finalLines.indexOf(stack[2].lineno) !== -1 && stack[2].colno === 350
    );
  }

  function isOpenTelemetryExportError(message, event, frames) {
    if (
      message.indexOf("OpenTelemetryClientError") !== -1 ||
      message.indexOf("Invalid OpenTelemetry Data") !== -1
    ) {
      return true;
    }

    if (hasFirstPartyFrame(frames) || hasVendorTrackedFrame(frames)) {
      return false;
    }

    // Sentry stores Error.name separately from Error.message (SHOPIFY-STOREFRONT-BV).
    return getExceptionValues(event).some(function (exception) {
      if (
        exception.type !== "OpenTelemetryClientError" ||
        exception.value !== "Server did not accept data"
      ) {
        return false;
      }

      let exceptionFrames = exception.stacktrace ? exception.stacktrace.frames || [] : [];
      return exceptionFrames.some(function (frame) {
        return /(?:^|\/)shopifycloud\/shop-js\/modules\//.test(frameFilename(frame));
      });
    });
  }

  function isTruncatedScriptError(message, frames) {
    if (message.indexOf("Unexpected end of script") === -1) {
      return false;
    }

    return !hasFirstPartyFrame(frames) && !hasVendorTrackedFrame(frames);
  }

  function isGenericAbortError(message, frames) {
    if (
      message.indexOf("AbortError") === -1 &&
      message.indexOf("The operation was aborted") === -1
    ) {
      return false;
    }

    return !hasFirstPartyFrame(frames) && !hasVendorTrackedFrame(frames);
  }

  function isInvalidStateError(message, frames) {
    if (message.indexOf("InvalidStateError: The object is in an invalid state") === -1) {
      return false;
    }

    return !hasFirstPartyFrame(frames);
  }

  function isKlaviyoOnsiteAssetFailure(message, frames) {
    if (message.indexOf("Load failed") === -1 && message.indexOf("Failed to fetch") === -1) {
      return false;
    }

    return hasFrameMatching(frames, /onsite\/js\//);
  }

  function isTrekkieFallbackInsertError(message, frames) {
    if (message.indexOf("insertBefore") === -1) {
      return false;
    }

    return hasFrameMatching(frames, /script\.onerror/);
  }

  function isStacklessThirdPartyRejection(message, frames) {
    if (hasFirstPartyFrame(frames)) {
      return false;
    }

    if (/^(?:Error: )?invalid origin$/.test(message)) {
      return true;
    }

    if (/^(?:Error: )?NotFoundError$/.test(message) && frames.length === 0) {
      return true;
    }

    if (/JSON\.parse: unexpected character/.test(message)) {
      return true;
    }

    if (message === "uncaught exception: undefined") {
      return true;
    }

    if (message.indexOf("Array.from requires an array-like object") !== -1) {
      return true;
    }

    if (/\bdata\.split is not a function/.test(message)) {
      return true;
    }

    if (message.indexOf("Maximum call stack size exceeded") !== -1 && frames.length === 0) {
      return true;
    }

    return false;
  }

  function isRecursiveInjectedScriptError(message, frames) {
    if (message.indexOf("Maximum call stack size exceeded") === -1) {
      return false;
    }

    return hasFrameMatching(frames, /checkForImage|findTopmostVisibleElement/);
  }

  function isPhotoSwipeStateRace(message, frames) {
    if (
      message.indexOf("undefined is not an object (evaluating 'tt.center')") === -1 &&
      message.indexOf("undefined is not an object (evaluating 't.vGap.top')") === -1
    ) {
      return false;
    }

    return hasFrameMatching(frames, /vendor-scripts-v11/);
  }

  function isShopJsInstrumentedFetchFailure(message, frames) {
    if (message !== "Failed to fetch" && message.indexOf("TypeError: Failed to fetch") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames) || hasVendorTrackedFrame(frames)) {
      return false;
    }

    return (
      hasFrameMatching(frames, /instrument\/fetch/) &&
      hasFrameMatching(frames, /shopifycloud\/shop-js/)
    );
  }

  function isGlobalCodeLoadFailed(message, frames) {
    if (message.indexOf("Load failed") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames) || hasVendorTrackedFrame(frames)) {
      return false;
    }

    return hasFrameMatching(frames, /global code\(/);
  }

  function isStorefrontPageUrlLoadFailed(message, frames) {
    if (message.indexOf("Load failed") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames) || hasVendorTrackedFrame(frames)) {
      return false;
    }

    if (frames.length !== 1) {
      return false;
    }

    return /^https:\/\/[^/]+\/(?:cart(?:\/|$)|collections\/|products\/|blogs\/|pages\/)/.test(
      frameFilename(frames[0])
    );
  }

  function isShopifyListenerLegacySyntaxError(event) {
    let values = getExceptionValues(event);
    if (values.length !== 1) return false;
    let exception = values[0];
    if (exception.type !== "SyntaxError" || exception.value !== "Unexpected token '='. Expected an opening '(' before a method's parameter list.") return false;
    let frames = exception.stacktrace && exception.stacktrace.frames;
    if (!frames || frames.length !== 1) return false;
    let frame = frames[0];
    // Shopify analytics listener static fields fail to parse in Safari 12.
    // Keep every other script, syntax error and additional caller reportable.
    let path = "/cdn/shopifycloud/storefront/assets/shop_events_listener-4e26a9ce.js";
    let filename = frameFilename(frame);
    // The browser SDK retains the absolute URL and uses "?" for unnamed frames.
    let knownSource = filename === path ||
      filename === "https://electroandcompany.com" + path ||
      filename === "https://www.electroandcompany.com" + path ||
      filename === "https://electroandco-2578.myshopify.com" + path;
    return knownSource && frame.lineno === 1 && (!frame.function || frame.function === "?");
  }

  function isOldBrowserShopifySyntaxError(message, frames) {
    if (
      message.indexOf("Unexpected reserved word") === -1 &&
      message.indexOf("Unexpected token") === -1
    ) {
      return false;
    }

    if (hasFirstPartyFrame(frames)) {
      return false;
    }

    return hasFrameMatching(
      frames,
      /shopifycloud\/shop-js|standard-actions|storefront\/standard-actions|trekkie\.storefront|\/wpm\//
    );
  }

  function isOldBrowserPageSyntaxError(message, frames) {
    if (
      message.indexOf("Unexpected reserved word") === -1 &&
      message.indexOf("Unexpected token") === -1
    ) {
      return false;
    }

    if (hasFirstPartyFrame(frames)) {
      return false;
    }

    return hasFrameMatching(
      frames,
      /^(?:\?\()?(?:blogs|cart|collections|pages|products|search)\//
    );
  }

  function isDomSyntaxPatternError(message, frames) {
    if (message.indexOf("The string did not match the expected pattern") === -1) {
      return false;
    }

    return !hasFirstPartyFrame(frames);
  }

  function isScrollThresholdReferenceError(message, frames) {
    if (message.indexOf("scrollThreshold is not defined") === -1) {
      return false;
    }

    return hasFrameMatching(frames, /termsAcceptance/);
  }

  function isBareTypeErrorLoadFailed(message, frames) {
    if (message !== "Load failed" && message.indexOf("TypeError: Load failed") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames) || hasVendorTrackedFrame(frames)) {
      return false;
    }

    return frames.length === 0;
  }

  function isNetworkErrorFetchResource(message, frames) {
    if (message.indexOf("NetworkError when attempting to fetch resource") === -1) {
      return false;
    }

    return !hasFirstPartyFrame(frames);
  }

  function isBareModuleImportFailure(message, frames) {
    if (message.indexOf("Importing a module script failed") === -1) {
      return false;
    }

    return !hasFirstPartyFrame(frames) && !hasVendorTrackedFrame(frames);
  }

  function isGtagAnalyticsNoise(message, frames) {
    if (/getDuration is not a function/.test(message)) {
      return hasFrameMatching(frames, /gtag\/js|www-widgetapi/);
    }

    return hasFrameMatching(frames, /gtag\/js/);
  }

  function isShopJsExportLoadFailed(message, frames) {
    if (message.indexOf("Load failed") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames)) {
      return false;
    }

    return hasFrameMatching(
      frames,
      /shopifycloud\/shop-js\/modules\/v2\/chunk\.utils/
    );
  }

  function isShopJsUnableToFetch(message) {
    return /Unable to fetch .*shopifycloud\/shop-js/.test(message);
  }

  function isStorefrontWebComponentsFailure(message, frames) {
    if (hasFirstPartyFrame(frames)) {
      return false;
    }

    if (
      /storefront\/web-components/.test(message) ||
      hasFrameMatching(frames, /storefront\/web-components/)
    ) {
      return true;
    }

    if (
      message.indexOf("is not a valid JavaScript MIME type") !== -1 &&
      hasFrameMatching(frames, /storefront\/web-components/)
    ) {
      return true;
    }

    if (
      message.indexOf("The operation is insecure") !== -1 &&
      hasFrameMatching(frames, /storefront\/web-components/)
    ) {
      return true;
    }

    return false;
  }

  function isShopifyFormsExtensionFailure(message, frames) {
    if (hasFirstPartyFrame(frames)) {
      return false;
    }

    if (/forms-\d+\/assets\/index/.test(message)) {
      return true;
    }

    if (hasFrameMatching(frames, /forms-\d+\/assets\/index/)) {
      return true;
    }

    if (
      message.indexOf("Unexpected end of script") !== -1 &&
      hasFrameMatching(frames, /forms-\d+\/assets\/index/)
    ) {
      return true;
    }

    return false;
  }

  function isTrekkieStorefrontLoadFailed(message, frames) {
    if (message.indexOf("Load failed") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames)) {
      return false;
    }

    return hasFrameMatching(frames, /trekkie\.storefront/);
  }

  function isShopPlatformAbortError(message, frames) {
    if (message.indexOf("AbortError") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames) || hasVendorTrackedFrame(frames)) {
      return false;
    }

    return hasFrameMatching(
      frames,
      /shopifycloud\/shop-js|\/wpm\/|shop_events_listener/
    );
  }

  function isShopifyPayLoadFailed(message, frames) {
    if (message.indexOf("Load failed") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames)) {
      return false;
    }

    return hasFrameMatching(frames, /shopify_pay\/storefront/);
  }

  function isShopEventsListenerFetchFailed(message, frames) {
    if (message !== "Failed to fetch" && message.indexOf("Failed to fetch") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames)) {
      return false;
    }

    return hasFrameMatching(frames, /shop_events_listener/);
  }

  function isWpmFetchFailed(message, frames) {
    if (message !== "Failed to fetch" && message.indexOf("Failed to fetch") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames)) {
      return false;
    }

    for (let index = 0; index < frames.length; index += 1) {
      let filename = frameFilename(frames[index]);

      if (filename.indexOf("/wpm/") === -1) {
        continue;
      }

      if (frames[index].function === "produce") {
        return false;
      }

      return true;
    }

    return false;
  }

  function isWpmLoadFailed(message, frames) {
    if (message.indexOf("Load failed") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames)) {
      return false;
    }

    for (let index = 0; index < frames.length; index += 1) {
      let filename = frameFilename(frames[index]);

      if (filename.indexOf("/wpm/") === -1) {
        continue;
      }

      if (frames[index].function === "produce") {
        return false;
      }

      return true;
    }

    return false;
  }

  function isGenericNetworkLoadFailed(message, frames) {
    if (message.indexOf("NetworkError: Load failed") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames)) {
      return false;
    }

    return frames.length === 0;
  }

  function isStorefrontPageUrlFetchFailed(message, frames) {
    if (message !== "Failed to fetch" && message.indexOf("Failed to fetch") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames) || hasVendorTrackedFrame(frames)) {
      return false;
    }

    if (frames.length !== 1) {
      return false;
    }

    return /^https:\/\/[^/]+\/(?:cart(?:\/|$)|collections\/|products\/|blogs\/|pages\/)/.test(
      frameFilename(frames[0])
    );
  }

  function isUnattributedDeliveryFailure(event, frames) {
    let values = getExceptionValues(event);

    if (values.length !== 1 || values[0].type !== "TypeError") {
      return false;
    }

    let exception = values[0];
    let mechanism = exception.mechanism;

    if (!mechanism || mechanism.handled !== false) {
      return false;
    }

    // 9N / AJ: exact browser cancellation and HTML module-response failures.
    // Neither event supplied a script URL or source frame to investigate.
    if (frames.length === 0 && mechanism.type === "onunhandledrejection") {
      return (
        exception.value === "cancelled" ||
        exception.value === "'text/html' is not a valid JavaScript MIME type."
      );
    }

    // C9: old WebView onerror supplies only the search page, with no code location.
    if (
      exception.value !== "Failed to fetch" ||
      mechanism.type !== "onerror" ||
      mechanism.synthetic !== true ||
      frames.length !== 1
    ) {
      return false;
    }

    let frame = frames[0];

    if (
      frame.function ||
      frame.lineno != null ||
      frame.colno != null ||
      frame.context_line ||
      (frame.pre_context && frame.pre_context.length) ||
      (frame.post_context && frame.post_context.length)
    ) {
      return false;
    }

    return /^(?:https:\/\/electroandcompany\.com)?\/search(?:[?#]|$)/.test(
      frame.abs_path || frameFilename(frame)
    );
  }

  function isBareInstrumentedFetchFailure(message, frames) {
    if (message !== "Failed to fetch" && message.indexOf("Failed to fetch") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames) || hasVendorTrackedFrame(frames)) {
      return false;
    }

    if (!hasFrameMatching(frames, /instrument\/fetch/)) {
      return false;
    }

    return !hasFrameMatching(frames, /shopifycloud\/shop-js/);
  }

  function isInstrumentedFetchNoise(message, frames) {
    if (message !== "Failed to fetch" && message.indexOf("TypeError: Failed to fetch") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames)) {
      return false;
    }

    if (!hasFrameMatching(frames, /instrument\/fetch/)) {
      return false;
    }

    return hasFrameMatching(
      frames,
      /shopifycloud\/perf-kit|\/wpm\/|shop_events_listener/
    );
  }

  function isBareFailedToFetch(message, frames) {
    if (message !== "Failed to fetch" && message.indexOf("TypeError: Failed to fetch") === -1) {
      return false;
    }

    return !hasFirstPartyFrame(frames) && !hasVendorTrackedFrame(frames) && frames.length === 0;
  }

  function isCorsScriptLoadDenied(message, frames) {
    if (message.indexOf("Cross-origin script load denied") === -1) {
      return false;
    }

    return !hasFirstPartyFrame(frames);
  }

  function isModelContextPermissionsError(message, frames) {
    if (message.indexOf("registerTool") === -1 && message.indexOf("ModelContext") === -1) {
      return false;
    }

    return hasFrameMatching(frames, /storefront\/src\/registration|shopifycloud/);
  }

  function isVendorScriptsBundleError(message, frames) {
    if (hasFirstPartyFrame(frames)) {
      return false;
    }

    return hasFrameMatching(frames, /vendor-scripts-v11/);
  }

  function isShopLoginInitRace(message, frames) {
    if (message.indexOf("shopLogin") === -1) {
      return false;
    }

    return hasFrameMatching(frames, /shopifycloud\/shop-js/);
  }

  function isInjectedBridgeReferenceError(message, frames) {
    if (
      message.indexOf("SCDynimacBridge") === -1 &&
      message.indexOf("Can't find variable: _G") === -1
    ) {
      return false;
    }

    return !hasFirstPartyFrame(frames);
  }

  function isMinifiedBaError(message, frames) {
    if (message !== "Ba" && message !== "Error: Ba") {
      return false;
    }

    return !hasFirstPartyFrame(frames) && !hasVendorTrackedFrame(frames);
  }

  function isPageAttributedCallStackOverflow(message, frames) {
    if (message.indexOf("Maximum call stack size exceeded") === -1) {
      return false;
    }

    return !hasFirstPartyFrame(frames) && !hasVendorTrackedFrame(frames);
  }

  function isMediaElementCapabilityError(message, frames) {
    if (
      message.indexOf("Picture-in-Picture") === -1 &&
      message.indexOf("media resource indicated by the src attribute") === -1 &&
      message.indexOf("does not have a video track") === -1 &&
      message.indexOf("fetching process for the media resource was aborted") === -1
    ) {
      return false;
    }

    return !hasFirstPartyFrame(frames);
  }

  function isSendBeaconCorsBlobError(message) {
    return (
      message.indexOf("sendBeacon") !== -1 &&
      message.indexOf("CORS-safelisted") !== -1
    );
  }

  function isGoogleMapsApiNoise(message, frames) {
    if (
      message.indexOf('Could not load "map"') === -1 &&
      message.indexOf('Could not load "marker"') === -1 &&
      message.indexOf("Blocked a frame with origin") === -1
    ) {
      return false;
    }

    return hasFrameMatching(frames, /maps-api-v3/) || !hasFirstPartyFrame(frames);
  }

  function isSentryProxyIllegalInvocation(message, frames) {
    if (message.indexOf("Illegal invocation") === -1) {
      return false;
    }

    return hasFrameMatching(frames, /browser\.sentry-cdn\.com|sentry-cdn\.com/);
  }

  function isWpmSyntaxNoise(message, frames) {
    if (
      message.indexOf("Unexpected EOF") === -1 &&
      message.indexOf("Unexpected end of script") === -1
    ) {
      return false;
    }

    return hasFrameMatching(frames, /\/wpm\//);
  }

  function isOldBrowserNumericLiteralSyntaxError(message, frames) {
    if (message.indexOf("No identifiers allowed directly after numeric literal") === -1) {
      return false;
    }

    return !hasFirstPartyFrame(frames);
  }

  function isUnexpectedTokenElseSyntaxError(message, frames) {
    if (message.indexOf("Unexpected token 'else'") === -1 && message.indexOf('Unexpected token "else"') === -1) {
      return false;
    }

    return !hasFirstPartyFrame(frames);
  }

  function isAndroidJavaBridgeNoise(message, frames) {
    if (
      message.indexOf("Java bridge method invocation error") === -1 &&
      message.indexOf("Java object is gone") === -1
    ) {
      return false;
    }

    return !hasFirstPartyFrame(frames);
  }

  function isA2zStatusUpdateNoise(message, frames) {
    if (message.indexOf("a2z.onStatusUpdate is not a function") === -1) {
      return false;
    }

    return !hasFirstPartyFrame(frames);
  }

  function isBareStatus502(message, frames) {
    if (message.indexOf("Failed with status 502") === -1) {
      return false;
    }

    return !hasFirstPartyFrame(frames);
  }

  function isUndefinedPromiseRejection(message, frames) {
    if (
      message.indexOf("Non-Error promise rejection captured with value: undefined") === -1 &&
      message !== "undefined"
    ) {
      return false;
    }

    return !hasFirstPartyFrame(frames) && !hasVendorTrackedFrame(frames);
  }

  function isThirdPartyFrontendDebugNoise(message, frames) {
    if (message.indexOf("this.debug") === -1) {
      return false;
    }

    return hasFrameMatching(frames, /resources\/frontend/) && !hasFirstPartyFrame(frames);
  }

  function isShopJsNamedExportMismatch(message, frames) {
    if (message.indexOf("does not provide an export named") === -1) {
      return false;
    }

    return (
      /shopifycloud\/shop-js/.test(message) ||
      hasFrameMatching(frames, /shopifycloud\/shop-js/)
    );
  }

  function isShopifyScriptHtmlSyntaxError(event) {
    let values = getExceptionValues(event);
    if (values.length !== 1) return false;
    let exception = values[0];
    if (exception.type !== "SyntaxError" || exception.value !== "Unexpected token '<'") {
      return false;
    }
    let frames = exception.stacktrace && exception.stacktrace.frames;
    if (!frames || !frames.length) return false;

    // These platform-owned scripts failed to parse on their first line.
    // Require every frame to identify one of the observed delivery paths.
    return frames.every(frame => {
      return frame.lineno === 1 &&
        /^https:\/\/electroandcompany\.com\/(?:cdn\/shopifycloud\/storefront\/assets\/storefront\/autosizes-[a-f0-9]+\.js|checkouts\/internal\/preloads\.js)(?:[?#].*)?$/.test(frameFilename(frame));
    });
  }

  function isStandardActionsFetchCancellation(event) {
    let values = getExceptionValues(event);
    if (values.length !== 1) return false;
    let exception = values[0];
    if (exception.type !== "TypeError" || exception.value !==
      "Unable to fetch https://cdn.shopify.com/storefront/standard-actions.js - see network log for details.\ncancelled") {
      return false;
    }

    let frames = exception.stacktrace && exception.stacktrace.frames;
    // The exact message identifies the platform request; do not hide callers
    // from theme functions, app scripts, or other assets that wrap that request.
    return !frames || frames.every(frame => {
      let filename = frameFilename(frame);
      let anonymous = !frame.function || frame.function === "<anonymous>" || frame.function === "?";
      return anonymous && !/\.js(?:[?#]|$)|\/assets\//.test(filename) &&
        /^https:\/\/electroandcompany\.com\/(?:collections|products|cart|search|pages|blogs)(?:[/?#]|$)/.test(filename);
    });
  }

  function isShopifyTelemetryNetworkFailure(event) {
    let values = getExceptionValues(event);
    if (values.length !== 1) return false;
    let exception = values[0];
    if (exception.type !== "TypeError" || exception.value !== "Failed to fetch") {
      return false;
    }
    let frames = exception.stacktrace && exception.stacktrace.frames;
    if (!frames || !frames.length) return false;
    let shopifyModule = /^https:\/\/cdn\.shopify\.com\/shopifycloud\/shop-js\/modules\/v2\/[^/?#]+\.esm\.js(?:[?#].*)?$/;
    let sdkBundle = /^https:\/\/browser\.sentry-cdn\.com\/\d+\.\d+\.\d+\/bundle\.min\.js(?:[?#].*)?$/;
    let hasExport = false;
    let hasTransport = false;

    let platformOnly = frames.every((frame, index) => {
      let filename = frameFilename(frame);
      if (shopifyModule.test(filename)) {
        if (/\.export(?:Metrics|Logs)$/.test(frame.function || "")) hasExport = true;
        if (/\.exportTo$/.test(frame.function || "")) hasTransport = true;
        return true;
      }
      // CQ/S raw stacks show this exact innermost fetch wrapper. Its
      // presence alone is insufficient: export + transport and every other
      // allowlisted frame below still establish the telemetry-only chain.
      if (index === frames.length - 1 &&
          filename === "event-observer-collector.js" && frame.function === "fetch" &&
          frame.lineno === 2 && frame.colno === 837) {
        return true;
      }
      if (sdkBundle.test(filename)) {
        return true;
      }
      return filename === "<anonymous>" || filename === "[native code]";
    });
    // AF/42 can omit the SDK wrapper. Shopify export + transport methods
    // establish telemetry ownership while every frame must remain allowlisted.
    return platformOnly && hasExport && hasTransport;
  }

  function isFingerprintMatchedInjectedRuntime(event, windowRef) {
    let values = getExceptionValues(event);
    if (values.length !== 1) return false;
    let exception = values[0];
    let frames = getFrames(event);
    let userAgent = getUserAgent(windowRef);

    // Tooling ownership is inferred from the isolated helper and browser identity;
    // no particular automation vendor has been established for this event.
    if (
      exception.type === "ReferenceError" &&
      exception.value === "BAS_SetResult is not defined" &&
      /Android [\d.]+/.test(userAgent) &&
      /YaBrowser\/25\.10\.6\.63\.00(?: |$)/.test(userAgent)
    ) {
      return frames.length === 1 && frameFilename(frames[0]) === "<anonymous>" &&
        !frames[0].function && frames[0].lineno === 142 && frames[0].colno === 3;
    }

    // The __DLD__ path and CMAC identity strongly indicate an injected runtime.
    // Its exact vendor is unconfirmed. Preserve other fetch errors and callers.
    if (exception.type !== "TypeError" || exception.value !== "Failed to fetch" ||
        !/Macintosh; Intel Mac OS X/.test(userAgent) ||
        !/CMAC 2\.1\.2\.01; Chrome\/118\.0\.5993\.119(?: |$)/.test(userAgent) ||
        frames.length !== 27 || !windowRef.location || !windowRef.location.origin) return false;

    let origin = windowRef.location.origin;
    if (!/^https:\/\/[^/]+$/.test(origin)) return false;
    let filename = frameFilename(frames[0]);
    if (filename.indexOf(origin + "/") !== 0 ||
        !/^\/__DLD__[a-f0-9]{64}\/resources\/frontend\.min\.js$/.test(filename.slice(origin.length))) return false;

    let nativePromises = 0;
    for (let index = 0; index < frames.length; index += 1) {
      let frame = frames[index];
      if (frameFilename(frame) === filename) continue;
      if (frameFilename(frame) !== "<anonymous>" || frame.function !== "new Promise" ||
          frame.lineno != null || frame.colno != null) return false;
      nativePromises += 1;
    }

    return nativePromises === 4 &&
      frames[18].function === "Xt.sendMessage" && frames[18].lineno === 1851 && frames[18].colno === 68 &&
      frames[26].function === "Xt.fetch" && frames[26].lineno === 1850 && frames[26].colno === 297;
  }

  function isShopifyVisualPreviewReplacementError(event, windowRef) {
    let values = getExceptionValues(event);
    if (values.length !== 1 || event.environment !== "preview" ||
        !windowRef.location || !windowRef.location.href) return false;
    let page;
    try {
      page = new URL(windowRef.location.href);
    } catch (error) {
      return false;
    }
    if (page.origin !== "https://electroandco-2578.myshopify.com" ||
        page.searchParams.get("source") !== "visualPreviewInitialLoad") return false;
    let exception = values[0];
    if (exception.type !== "SyntaxError" || exception.value !==
        "Failed to execute 'replaceWith' on 'Element': Unexpected token '-'") return false;
    let frames = exception.stacktrace && exception.stacktrace.frames;
    if (!frames || !frames.length) return false;

    // CE, Shopify Plus 70162902: confirmed editor-only preview replacement.
    // Pin the observed bundle and failing call; keep other editor/theme errors.
    let bundle = "https://cdn.shopify.com/shopifycloud/online-store-web/assets/main/visual-preview-modules-ad225b8b1dbed6d2a82320e9075841af7f0b6ba6.1.js";
    let last = frames[frames.length - 1];
    return frameFilename(last) === bundle && last.function === "Mg" &&
      last.lineno === 7 && last.colno === 2029 && frames.every(frame => {
        return frameFilename(frame) === bundle ||
          (frameFilename(frame) === "<anonymous>" &&
            (frame.function === "Array.filter" || frame.function === "Array.some"));
      });
  }

  function isNintendoPolyfillAllocationFailure(event, windowRef) {
    // Shopify Plus 70162902 confirms this Nintendo applet is unsupported.
    // Keep supported browsers and other allocation paths visible.
    if (getUserAgent(windowRef) !== "Mozilla/5.0 (Nintendo Switch; WifiWebAuthApplet) AppleWebKit/613.0 (KHTML, like Gecko) NF/6.0.3.31.11 NintendoBrowser/5.1.0.55481") return false;
    let values = getExceptionValues(event);
    if (values.length !== 1 || values[0].type !== "RangeError" ||
        values[0].value !== "Out of memory") return false;
    let frames = values[0].stacktrace && values[0].stacktrace.frames;
    if (!frames || frames.length !== 7) return false;
    let bundle = "/cdn/shopifycloud/importmap-polyfill/es-modules-shim.2.4.0.js";
    let nativeFunctions = ["promiseReactionJob", "promiseReactionJobWithoutPromise",
      "?", "asyncFunctionResume", null, null, "ArrayBuffer"];
    return frames.every((frame, index) => {
      if (frame.abs_path && frame.abs_path !== frame.filename) return false;
      if (index === 4 || index === 5) {
        return frameFilename(frame) === bundle && frame.lineno === 1 &&
          frame.colno === (index === 4 ? 40725 : 10177) &&
          frame.function === (index === 4 ? "?" : "parse");
      }
      return frameFilename(frame) === "[native code]" &&
        frame.function === nativeFunctions[index];
    });
  }

  function isGoGuardianPostMessageFailure(event) {
    // D1: the injected GoGuardian runtime failed entirely inside its own asset.
    // Match the observed build and retain changed or mixed application stacks.
    let values = getExceptionValues(event);
    if (values.length !== 1 || values[0].type !== "TypeError" ||
        values[0].value !== "Cannot read properties of null (reading 'postMessage')") return false;
    let frames = values[0].stacktrace && values[0].stacktrace.frames;
    if (!frames || frames.length !== 3) return false;
    let asset = "https://internal.goguardian/asset/asset.js";
    let functions = ["F", "Object.getItem", "A"];
    let columns = [692322, 4847, 3735];
    return frames.every((frame, index) => {
      let absolute = frame.abs_path || frame.absPath;
      if (frame.abs_path && frame.absPath && frame.abs_path !== frame.absPath) return false;
      let sourceMatches = frame.filename === asset && (!absolute || absolute === asset);
      // Sentry normalizes the native event filename to a path on retrieval.
      if (frame.filename === "/asset/asset.js" && absolute === asset) sourceMatches = true;
      return sourceMatches && frame.function === functions[index] &&
        frame.lineno === 2 && frame.colno === columns[index];
    });
  }

  function sentryShouldDropEvent(event) {
    if (isGoGuardianPostMessageFailure(event)) return true;
    if (isNintendoPolyfillAllocationFailure(event, window)) return true;
    if (isShopifyVisualPreviewReplacementError(event, window)) return true;
    if (isFingerprintMatchedInjectedRuntime(event, window)) return true;
    // A1/A0/9A came from a copied storefront running on this exact host.
    // Use the browser's current location; event tags and frame URLs are not proof
    // that our theme is executing on the clone. Shopify previews remain enabled.
    if (window.location && window.location.hostname === "apexmall.shop") {
      return true;
    }

    let message = getErrorMessage(event);
    let frames = getFrames(event);

    if (isShopifyScriptHtmlSyntaxError(event)) {
      return true;
    }

    if (isStandardActionsFetchCancellation(event)) {
      return true;
    }

    if (isShopifyTelemetryNetworkFailure(event)) {
      return true;
    }

    if (isTermsLoadFailureMessage(message)) {
      return true;
    }

    if (isTermsCheckoutDiagnosticMessage(message)) {
      return true;
    }

    if (isShopJsChunkImportFailure(message)) {
      return true;
    }

    if (isWebPixelsManagerInitFailure(message, frames)) {
      return true;
    }

    if (isKlaviyoChunkLoadFailure(message, frames)) {
      return true;
    }

    if (isShopJsDynamicImportFailure(message)) {
      return true;
    }

    if (isShopJsModuleImportFailure(message, frames)) {
      return true;
    }

    if (isJsonLdTelephoneParserError(message, frames)) {
      return true;
    }

    if (isBrowserExtensionTabError(message)) {
      return true;
    }

    if (isSymantecBrowserInjectionError(message)) {
      return true;
    }

    if (isMediaPlaybackInterruption(message)) {
      return true;
    }

    if (isImportMapSrcdocMutationError(message, frames)) {
      return true;
    }

    if (isNativeBrowserBridgeFailure(event, window)) {
      return true;
    }

    if (isInAppBrowserWebkitError(message, frames)) {
      return true;
    }

    if (isInAppBrowserBridgeFrameError(frames)) {
      return true;
    }

    if (isObsoleteAndroidWebViewInitError(message, window)) {
      return true;
    }

    if (isProxyRewrittenPageError(frames, event)) {
      return true;
    }

    if (isGoogleAppInstrumentationError(frames)) {
      return true;
    }

    if (isClickSimulatorChildrenError(message, frames, event)) {
      return true;
    }

    if (isDictionaryTimeoutRejection(event, frames)) {
      return true;
    }

    if (isGoogleTranslateLaRejection(event, frames, window)) {
      return true;
    }

    if (isGoogleIosGeneratorRejection(event, frames, window)) {
      return true;
    }

    if (isOpenTelemetryExportError(message, event, frames)) {
      return true;
    }

    if (isTruncatedScriptError(message, frames)) {
      return true;
    }

    if (isGenericAbortError(message, frames)) {
      return true;
    }

    if (isInvalidStateError(message, frames)) {
      return true;
    }

    if (isKlaviyoOnsiteAssetFailure(message, frames)) {
      return true;
    }

    if (isTrekkieFallbackInsertError(message, frames)) {
      return true;
    }

    if (isStacklessThirdPartyRejection(message, frames)) {
      return true;
    }

    if (isRecursiveInjectedScriptError(message, frames)) {
      return true;
    }

    if (isPhotoSwipeStateRace(message, frames)) {
      return true;
    }

    if (isShopJsInstrumentedFetchFailure(message, frames)) {
      return true;
    }

    if (isGlobalCodeLoadFailed(message, frames)) {
      return true;
    }

    if (isStorefrontPageUrlLoadFailed(message, frames)) {
      return true;
    }

    if (isShopifyListenerLegacySyntaxError(event)) {
      return true;
    }

    if (isOldBrowserShopifySyntaxError(message, frames)) {
      return true;
    }

    if (isOldBrowserPageSyntaxError(message, frames)) {
      return true;
    }

    if (isDomSyntaxPatternError(message, frames)) {
      return true;
    }

    if (isScrollThresholdReferenceError(message, frames)) {
      return true;
    }

    if (isBareTypeErrorLoadFailed(message, frames)) {
      return true;
    }

    if (isNetworkErrorFetchResource(message, frames)) {
      return true;
    }

    if (isBareModuleImportFailure(message, frames)) {
      return true;
    }

    if (isGtagAnalyticsNoise(message, frames)) {
      return true;
    }

    if (isShopJsExportLoadFailed(message, frames)) {
      return true;
    }

    if (isShopJsUnableToFetch(message)) {
      return true;
    }

    if (isStorefrontWebComponentsFailure(message, frames)) {
      return true;
    }

    if (isShopifyFormsExtensionFailure(message, frames)) {
      return true;
    }

    if (isTrekkieStorefrontLoadFailed(message, frames)) {
      return true;
    }

    if (isShopPlatformAbortError(message, frames)) {
      return true;
    }

    if (isShopifyPayLoadFailed(message, frames)) {
      return true;
    }

    if (isShopEventsListenerFetchFailed(message, frames)) {
      return true;
    }

    if (isWpmFetchFailed(message, frames)) {
      return true;
    }

    if (isWpmLoadFailed(message, frames)) {
      return true;
    }

    if (isGenericNetworkLoadFailed(message, frames)) {
      return true;
    }

    if (isStorefrontPageUrlFetchFailed(message, frames)) {
      return true;
    }

    if (isUnattributedDeliveryFailure(event, frames)) {
      return true;
    }

    if (isBareInstrumentedFetchFailure(message, frames)) {
      return true;
    }

    if (isInstrumentedFetchNoise(message, frames)) {
      return true;
    }

    if (isBareFailedToFetch(message, frames)) {
      return true;
    }

    if (isCorsScriptLoadDenied(message, frames)) {
      return true;
    }

    if (isModelContextPermissionsError(message, frames)) {
      return true;
    }

    if (isVendorScriptsBundleError(message, frames)) {
      return true;
    }

    if (isShopLoginInitRace(message, frames)) {
      return true;
    }

    if (isInjectedBridgeReferenceError(message, frames)) {
      return true;
    }

    if (isMinifiedBaError(message, frames)) {
      return true;
    }

    if (isPageAttributedCallStackOverflow(message, frames)) {
      return true;
    }

    if (isMediaElementCapabilityError(message, frames)) {
      return true;
    }

    if (isSendBeaconCorsBlobError(message)) {
      return true;
    }

    if (isGoogleMapsApiNoise(message, frames)) {
      return true;
    }

    if (isSentryProxyIllegalInvocation(message, frames)) {
      return true;
    }

    if (isWpmSyntaxNoise(message, frames)) {
      return true;
    }

    if (isOldBrowserNumericLiteralSyntaxError(message, frames)) {
      return true;
    }

    if (isUnexpectedTokenElseSyntaxError(message, frames)) {
      return true;
    }

    if (isAndroidJavaBridgeNoise(message, frames)) {
      return true;
    }

    if (isA2zStatusUpdateNoise(message, frames)) {
      return true;
    }

    if (isBareStatus502(message, frames)) {
      return true;
    }

    if (isUndefinedPromiseRejection(message, frames)) {
      return true;
    }

    if (isThirdPartyFrontendDebugNoise(message, frames)) {
      return true;
    }

    if (isShopJsNamedExportMismatch(message, frames)) {
      return true;
    }

    return false;
  }

  window.sentryShouldDropEvent = sentryShouldDropEvent;
})();
